<template>
  <div>
    <div class="result">
      <div class="collapse">
        <Collapse
          v-for="(item, index) in surveyResult?.surveyQuestions"
          :key="item.id"
          :isFirstCollapse="index === 0"
          :isLastCollapse="index === surveyResult?.surveyQuestions.length - 1"
          collapseColor="#4e5c78"
        >
          <template v-slot:preview>
            <p class="result-title">
              {{ item.value }}
            </p>
          </template>
          <template v-slot:detail>
            <div
              class="rectangle"
              v-for="(answer, index) in item?.surveyQuestionAnswers"
              :key="index"
            >
              <div
                class="rectangle-percent"
                :style="{ width: answer.percentage + '%' }"
              ></div>
              <span class="percent-value">
                %{{ $filters.formatNumberFilter(answer.percentage) }}
              </span>
              <span class="answer">{{ answer.value.slice(0, 25) }}</span>
            </div>
          </template>
        </Collapse>
      </div>
    </div>
    <div class="result-footer">
      <div class="button">
        <AppButton secondary title="Kapat" id="close"></AppButton>
      </div>
    </div>
  </div>
</template>

<script>
import { AppButton } from '@n11/so-ui-components';
import Collapse from '../common/Collapse/Collapse';

export default {
  name: 'SurveyResult',
  components: {
    Collapse,
    AppButton,
  },
  props: {
    surveyResult: Object,
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';

.result {
  margin-top: 20px;
  width: 100%;
  min-height: 295px;
  overflow-y: scroll;

  .collapse {
    margin: 0 20px;
  }

  .question {
    display: flex;
    margin-left: 20px;

    .text {
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        margin: 3px 0 3px 12px;
        font-size: 13px;
        line-height: 1.38;
        color: $dark-gray-5;
      }
    }
  }

  .hr {
    margin: 7px 20px 12px 54px;
  }
}

.result-footer {
  margin-top: 20px;

  .button {
    width: 82px;
    height: 40px;
    margin-left: 20px;
  }
}

.rectangle {
  width: 100%;
  margin-top: 10px;
  padding: 2px 12px;
  position: relative;

  &-percent {
    background-color: $green-5;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 6px;
    height: 100%;
  }

  .percent-value {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.33;
    color: $colorN00;
    position: relative;
  }

  .answer {
    margin: 1px 0 1px 4px;
    font-size: 13px;
    line-height: 1.38;
    letter-spacing: -0.05px;
    color: $colorN00;
    position: relative;
  }
}

.result-title {
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.05px;
  color: $colorN00;
}
</style>
